// extracted by mini-css-extract-plugin
export var widgets = "bN_fF";